import React, { useEffect, useState } from 'react';
import { Modal, Box } from '@mui/material';
import { FaTimes } from 'react-icons/fa';
import config from '../../config';
// import { paths, stops } from '../../utils/data';
import WrappedMap from './Map';
import { apiCall } from '../../../service';

const ModalDiv = ({ open, handleClose, jobId, jobDescription, vehicleNo, paths, stops }) => {

    const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_MAP_KEY}`;
    const [jobDetails, setJobDetails] = useState([])

    const formatDate = (isoDateString) => {
        let dateIST = new Date(isoDateString);
        // const dateUTC = new Date(isoDateString);
        // const utcTime = dateUTC.getTime();
        // const dateIST = new Date(utcTime);
        // dateIST.setHours(dateIST.getHours() + 5);
        // dateIST.setMinutes(dateIST.getMinutes() + 30);
        return dateIST.toLocaleString('en-IN', {
            timeZone:'Asia/Kolkata',
            hour: 'numeric',
            minute: 'numeric',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour12: true,
        });
        
        // return (d.toLocaleString(undefined , {timeZone:'Asia/Kolkata'}));
    };

    useEffect(() => {
        const fetchData = async () => {
            if (jobId != null) {
                const payload = {
                    body: {
                        "jobid": jobId,
                    },
                    method: 'POST',
                    host: config.apiEndpoints.jobsDetail.host,
                    endPoint: config.apiEndpoints.jobsDetail.url,
                }
                const data = await apiCall(payload)
                if(data && data.data){
                    setJobDetails(data.data.rows)
                }
                else{
                    setTimeout(()=>{
                        handleClose()
                    },[20000])
                }
            }
        }

        fetchData();
        setInterval(() => {
            fetchData();
        }, 60000);

    }, [jobId])
    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                minHeight: 600,
                width: {
                    xs: 400,
                    sm: 600,
                    md: 800,
                    lg: 1100,
                    xl: 1800
                },
                height: '80vh',
                maxHeight: "80vh",
                overflow: 'hidden'
            }}>
                <div className='madal_div'>
                    <div>
                        <span>{jobDescription}</span>
                        <button className="menu-btn">
                            <FaTimes size={24} onClick={() => handleClose()} />
                        </button>
                    </div>
                </div>
                <div className='modal_detail'>
                    <div className='modal_detail_main'>
                        <div className='source_div'>
                            <span>Source</span>
                        </div>
                        <div className="divider-container"
                            style={{
                                position: 'relative',
                                height: '100%',
                                display: 'grid',
                                gridTemplateColumns: '1fr 20px 1fr',
                                gridAutoRows: 'min-content',
                                alignItems: 'flex-start',
                            }}
                        >
                            {jobDetails.map((boarding, index) => (
                                <React.Fragment key={index}>
                                    {/* Left side for schedule arrival and ATA */}
                                    <div style={{ textAlign: 'right', paddingRight: '10px', paddingTop: '48px' }}>
                                        <div className='font_Size'>
                                            <span style={{ color: "green" }}> Sch_Arrv:</span>
                                            <span> {formatDate(boarding.schedule_arrival)}</span></div>
                                        <div className='font_Size'>
                                            {boarding.ATA == null ?
                                                <>
                                                    {
                                                        boarding.ETA === 0 ? "" :
                                                            <>
                                                                <span style={{ color: "red" }}> Est_Arr:</span>
                                                                <span> {formatDate(boarding.ETA)}</span>
                                                            </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    <span style={{ color: "green" }}> Act_Arrv:</span>
                                                    <span> {formatDate(boarding.ATA)}</span>
                                                </>}

                                        </div>
                                    </div>

                                    {/* Dot and vertical line */}
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            position: 'relative',
                                            padding: '22px 0',
                                        }}
                                    >
                                        {/* Dot */}
                                        <div
                                            style={{
                                                width: '10px',
                                                height: '10px',
                                                borderRadius: '50%',
                                                backgroundColor: 'green',
                                                zIndex: 2,
                                            }}
                                        ></div>

                                        {/* Vertical Line */}
                                        {index < jobDetails.length - 1 && (
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '15%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, 0)',
                                                    width: '2px',
                                                    height: 'calc(100% + 150px)',
                                                    backgroundColor: '#000',
                                                    zIndex: 1,
                                                }}
                                            ></div>
                                        )}
                                    </div>

                                    {/* Right side for name, schedule dept, and ATD */}
                                    <div style={{ textAlign: 'left', paddingLeft: '10px', paddingTop: '15px' }}>
                                        <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                                            {boarding.AddressBook.name}
                                        </div>
                                        <div className='font_Size'>
                                            <span style={{ color: "green" }}> Sch_Dept:</span>
                                            <span> {formatDate(boarding.schedule_dept)}</span>
                                        </div>
                                        <div className='font_Size'>
                                            {boarding.ATD == null ?
                                                ""
                                                :
                                                <>
                                                    <span style={{ color: "green" }}> Act_Dept:</span>
                                                    <span> {formatDate(boarding.ATD)}</span>
                                                </>}
                                        </div>

                                    </div>
                                </React.Fragment>
                            ))}
                            <div
                                style={{
                                    gridColumn: '2',
                                    marginTop: '50px',
                                }}
                                className='source_div'
                            >
                                Destination
                            </div>
                        </div>
                    </div>
                    <div className='modal_map'>
                        {stops.length > 0 && paths.length > 0 ? (
                            <WrappedMap
                                paths={paths}
                                stops={stops}
                                vehicleNo={vehicleNo}
                                jobId={jobId}
                                googleMapURL={mapURL}
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={<div className='mapContainer' />}
                                mapElement={<div style={{ height: `100%` }} />}
                            />
                        ) : (
                            <p>Loading....</p>
                        )}
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

export default ModalDiv;
